import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserStatusRefreshService {
  private readonly statusChangedSubject = new Subject<void>();
  readonly statusChanged$ = this.statusChangedSubject.asObservable();

  notifyStatusChanged(): void {
    this.statusChangedSubject.next();
  }
}
